import { cn } from '@repo/ui/src/lib/utils';
import { orgInitials } from './orgMenuItems';

/** The org's logo where there is one, its initials in a brand-tint square where
 *  there is not. Shared by the sidebar trigger, the menu/sheet header, the
 *  switcher rows and the phone top-bar button, so they can never disagree. */
export function OrgAvatar({ name, logoUrl, className }: { name?: string | null; logoUrl?: string | null; className?: string }) {
  if (logoUrl) {
    return <img src={logoUrl} alt="" className={cn('shrink-0 rounded-md border border-surface-200 object-cover', className)} />;
  }
  return (
    <span
      aria-hidden
      className={cn('flex shrink-0 items-center justify-center rounded-md bg-brand-50 text-[12px] font-bold text-brand-700', className)}
    >
      {orgInitials(name)}
    </span>
  );
}
